import { render, staticRenderFns } from "./LateralTitleElement.vue?vue&type=template&id=16885931&scoped=true&"
import script from "./LateralTitleElement.vue?vue&type=script&lang=js&"
export * from "./LateralTitleElement.vue?vue&type=script&lang=js&"
import style0 from "./LateralTitleElement.vue?vue&type=style&index=0&id=16885931&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16885931",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
installComponents(component, {
  VListTile,
  VListTileContent,
})
